module.exports = __webpack_public_path__ + "static/media/front-runner-films-logo.44b30a6a.png";